import { render, staticRenderFns } from "./ModalAbout.vue?vue&type=template&id=28d1e350&scoped=true"
import script from "./ModalAbout.vue?vue&type=script&lang=js"
export * from "./ModalAbout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d1e350",
  null
  
)

export default component.exports